// extracted by mini-css-extract-plugin
export var caption = "Image-module--caption--sUUDH";
export var component = "Image-module--component--Z9uTG";
export var credit = "Image-module--credit--OVykW";
export var img = "Image-module--img--ieCfj";
export var isCompact = "Image-module--isCompact--0G-hc";
export var link = "Image-module--link--p07Vx";